import { Scrollbar } from './scrollbar';
/**
 * ScrollbarY component.
 */
export const ScrollbarY = (options) => {
    return Scrollbar(Object.assign(Object.assign({}, options), { orientation: 'vertical' }));
};
ScrollbarY.props = Object.assign(Object.assign({}, Scrollbar.props), { defaultPosition: 'left' });
//# sourceMappingURL=scrollbarY.js.map